import React from 'react';
import { Table, Divider, Button, Popconfirm, Breadcrumb, Form, Input, Row, Col, message } from 'antd';
import { defaultPageSize, api, onGet, onPost } from '../../../core/api3';
import AccountEditModal from './AccountEditModal';
import MessageModal from '../MessageModal';
import DynamicPasswordModal from '../DynamicPasswordModal';


const { Column } = Table;


class AccountView extends React.Component {

    constructor() {
        super();
        this.state = {
            accounts: [],
            pageNumber: 1,
            pageSize: defaultPageSize,
            totalPage: 0,
            totalRow: 0,
            accountModalVisible: false,
            dynamicPasswordModalVisible: false,
            messageModalVisible: false,
            type: '',
            accountId: '',
            platformName: '',
            password: '',
            message: ''
        }
        this.loadData = this.loadData.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.onModalFinish = this.onModalFinish.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        onGet(api.listPlatformAccount.url, api.listPlatformAccount.params(this.props.form.getFieldValue('search'), this.state.pageNumber, this.state.pageSize)).then(response => {
            if (response === undefined) {
                return;
            }
            response.dataList.forEach(account => {
                account.key = account.id;
                // account.createTime = moment(account.createTime * 1000).format('YYYY-MM-DD HH:mm');
                account.createTime = account.createTime1;
                account.lastUpdateTime = account.lastUpdateTime;
            });
            this.setState({
                accounts: response.dataList,
                totalPage: this.state.pageNumber,
                totalRow: response.dataSize
            });
        });
    }

    onClick(type, item) {
        switch (type) {
            case 'query':
                this.setState({ pageNumber: 1 }, () => {
                    this.loadData();
                });
                break;
            case 'reset':
                this.props.form.setFieldsValue({ search: '' });
                this.setState({ pageNumber: 1 }, () => {
                    this.loadData();
                });
                break;
            case 'update':
                this.setState({ dynamicPasswordModalVisible: true, type: 'update', accountId: item.key, platformName: item.name });
                break;
            case 'delete':
                this.setState({ dynamicPasswordModalVisible: true, type: 'delete', accountId: item.key });
                break;
            case 'password':
                this.setState({ dynamicPasswordModalVisible: true, type: 'password', accountId: item.key });
                break;
            case 'login':
                window.open(item.platformUrl);
                break;
            case 'download':
                this.setState({ dynamicPasswordModalVisible: true, type: 'download' });
                break;
            default:
                break;
        }
    }

    onModalClose() {
        this.setState({ accountModalVisible: false, dynamicPasswordModalVisible: false, messageModalVisible: false });
    }

    onModalFinish(type) {
        switch (type) {
            case 'update':
                this.setState({ dynamicPasswordModalVisible: false }, () => {
                    this.setState({ accountModalVisible: true });
                });
                break;
            case 'delete':
                this.setState({ dynamicPasswordModalVisible: false }, () => {
                    onPost(api.deletePlatformAccount.url, api.deletePlatformAccount.params(this.state.accountId)).then(response => {
                        if (response === undefined) {
                            return;
                        }
                        message.success('删除成功');
                        this.loadData();
                    });
                });
                break;
            case 'account':
                this.setState({ accountModalVisible: false }, () => {
                    this.loadData();
                });
                break;
            case 'password':
                this.setState({ dynamicPasswordModalVisible: false }, () => {
                    onGet(api.getPlatformAccountPassword.url, api.getPlatformAccountPassword.params(this.state.accountId)).then(response => {
                        if (response === undefined) {
                            return;
                        } 
                        this.setState({ messageModalVisible: true }, () => {
                            this.setState({ message: response });
                        });
                    });
                });
                break;
            case 'download':
                this.setState({ dynamicPasswordModalVisible: false }, () => {
                    onPost(api.downloadPlatformAccount.url).then(response => {
                        if (response === undefined) {
                            return;
                        }
                        window.open(response);
                    });
                });
                break;
            default:
                break;
        }
    }

    onChangePage(pageNumber) {
        this.setState({ pageNumber: pageNumber }, () => {
            this.loadData();
        });
    }

    render() {
        return (
            <div>
                <Breadcrumb className="breadcrumb">
                    <Breadcrumb.Item><a href="#/index">首页</a></Breadcrumb.Item>
                    <Breadcrumb.Item>账号管理</Breadcrumb.Item>
                </Breadcrumb>
                <div className="content">
                    <Form className="form-inline">
                        <Row gutter={24}>
                            <Col span={8}>
                                <Form.Item label="搜索" >
                                    {this.props.form.getFieldDecorator('search', {})(
                                        <Input placeholder="请输入平台名称或用户名进行搜索" maxLength="20" />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <span>
                                    <Button type="primary" onClick={() => this.onClick('query')} style={{ marginRight: 10 }}>查询</Button>
                                    <Button type="primary" onClick={() => this.onClick('reset')}>重置</Button>
                                </span>
                            </Col>
                        </Row>
                    </Form>
                    <Button type="primary" style={{ marginBottom: 20 }} onClick={() => this.onClick('download')}>下载</Button>
                    <Table dataSource={this.state.accounts} pagination={{
                        current: this.state.pageNumber, total: this.state.totalRow, defaultPageSize: this.state.pageSize,
                        onChange: pageNumber => { this.onChangePage(pageNumber) }
                    }}>
                        <Column title="平台名称" dataIndex="platformName" align="center" />
                        <Column title="用户名" dataIndex="username" align="center" />
                        <Column title="密码" align="center" render={item => (
                            <a onClick={() => this.onClick('password', item)}>查看密码</a>
                        )} />
                        <Column title="标签" dataIndex="tag" align="center" />
                        <Column title="添加时间" dataIndex="createTime" align="center" />
                        <Column title="最后更新时间" dataIndex="lastUpdateTime" align="center" />
                        <Column title="操作" align="center" render={item => (
                            <span>
                                <a onClick={() => this.onClick('login', item)}>前往登录</a>
                                <Divider type="vertical" />
                                <a onClick={() => this.onClick('update', item)}>编辑</a>
                                <Divider type="vertical" />
                                <Popconfirm title="确定要删除这条记录？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('delete', item)}>
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        )} />
                    </Table>
                </div>
                {this.state.accountModalVisible &&
                    <AccountEditModal isAdd={false} accountId={this.state.accountId} platformName={this.state.platformName}
                        onModalCancel={this.onModalClose} onModalFinish={() => this.onModalFinish('account')} />
                }
                {this.state.dynamicPasswordModalVisible &&
                    <DynamicPasswordModal type={this.state.type} onModalCancel={this.onModalClose} onModalFinish={type => this.onModalFinish(type)} />
                }
                {this.state.messageModalVisible &&
                    <MessageModal title="密码" content={this.state.message} onModalCancel={this.onModalClose} />
                }
            </div>
        );
    }

}

const AccountPage = Form.create()(AccountView);
export default AccountPage;


// WEBPACK FOOTER //
// ./src/page/jsx/account/AccountPage.jsx